import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './FeedbackForm.css';
import Navbar from '../Navbar';
import { submitContactForm } from '../../utils/contact';
import { useLogin } from '../../context/LoginProvider';

const FeedbackForm = () => {
  const { userData, isLoggedIn } = useLogin();
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [category, setCategory] = useState('general');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const formData = {
        name: isLoggedIn ? userData.name : 'Anonymous User',
        email: isLoggedIn ? userData.email : 'connect@soulmegle.com',
        subject: 'Feedback',
        message: `Rating: ${rating}/5\nCategory: ${category}\nFeedback: ${feedback}\n\nUser Information:\nUsername: ${isLoggedIn ? userData.username : 'Not logged in'}\nUser Type: ${isLoggedIn ? 'Registered User' : 'Guest'}`
      };

      const response = await submitContactForm(formData);
      setSubmitted(true);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      if (error.message.toLowerCase().includes('too many')) {
        setError('Please wait a few minutes before submitting another feedback.');
      } else {
        setError('Failed to submit feedback. Please try again later.');
      }
    }
  };

  return (
    <>
      <Navbar />
      <motion.div
        className="feedback-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {!submitted ? (
          <>
            <h2>We Value Your Feedback</h2>
            <form onSubmit={handleSubmit}>
              <div className="rating-container">
                <p>How would you rate your experience?</p>
                <div className="star-rating">
                  {[...Array(5)].map((_, index) => {
                    const ratingValue = index + 1;
                    return (
                      <label key={index}>
                        <input
                          type="radio"
                          name="rating"
                          value={ratingValue}
                          onClick={() => setRating(ratingValue)}
                        />
                        <span
                          className={`star ${(hover || rating) >= ratingValue ? 'active' : ''}`}
                          onMouseEnter={() => setHover(ratingValue)}
                          onMouseLeave={() => setHover(0)}
                        >
                          ★
                        </span>
                      </label>
                    );
                  })}
                </div>
              </div>

              <div className="feedback-input">
                <select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required
                >
                  <option value="general">General Experience</option>
                  <option value="technical">Technical Issues</option>
                  <option value="feature">Feature Request</option>
                  <option value="other">Other</option>
                </select>

                <textarea
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  placeholder="Share your thoughts with us..."
                  required
                />
              </div>

              {error && <p className="error-message">{error}</p>}

              <button type="submit" disabled={!rating}>Submit Feedback</button>
            </form>
          </>
        ) : (
          <div className="success-message">
            <h3>Thank You for Your Feedback!</h3>
            <p>Your input helps us improve our service.</p>
          </div>
        )}
      </motion.div>
    </>
  );
};

export default FeedbackForm;